import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/Navbar/Navbar'
import Logo from '../../images/NewWFCOLogo2.svg'
import StudiesList from '../../components/StudiesList/studieslist';

import { homepgNavbarData } from '../../data/data';
import { homepgFooterData } from '../../data/data';
import { studiesList } from '../../data/data';

const Studies = () => {
  return (
    <Fragment>
        <Navbar hclass={'wpo-site-header-s1'} topbarNone={'topbar-none'} Logo={Logo} data={homepgNavbarData}/>
        <PageTitle pageTitle={'Studies'} pagesub={'Studies'}/> 
        <StudiesList data={studiesList}/>
        <Footer logo={Logo} data={homepgFooterData}/>
    </Fragment>
  );
};

export default Studies;
